
export enum SellingMethod {
  Auction= 'Auction',
  DirectSale= 'DirectSale',
  OfflineSale= 'OfflineSale',
  DealerSale= 'DealerSale',

}